import { render } from "./community.html?vue&type=template&id=2f8c55e0&ts=true"
import script from "./community.vue?vue&type=script&lang=ts"
export * from "./community.vue?vue&type=script&lang=ts"

import "./../content/content.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__